import { formURL } from '@wsc/utils/apiUtils';
import { todoMessage } from '@wsc/utils/consoleHelpers';

export const getSceneType = (sceneData) => {
	// not all scenes have scene_type prop as it was only recently added
	let sceneType = sceneData?.scene_type;
	if (!sceneType && sceneData?.cube_map_dir) sceneType = 'cubemap_scene';
	else if (!sceneType && (sceneData?.flat_scene_url || sceneData?.image))
		sceneType = 'flat_scene';
	return sceneType;
};

export const extractHotspotInfo = (data = {}) => ({
	hotspot_id: data?.hotspotId,
	hotspot_name: data?.name,
	hotspot_type: data?.hotspot_type,
});

export const extractNavHotspotInfo = (data = {}) => ({
	hotspot_id: data?._id?.$oid,
	hotspot_name: data?.name,
	hotspot_type: data?.type,
});

export const getSceneCubeMapDir = (scene, localesEnabled, activeLocale) => {
	if (
		localesEnabled &&
		'translations' in scene &&
		activeLocale in scene.translations
	) {
		return formURL(scene.translations[activeLocale].cube_map_dir);
	}
	return formURL(scene.cube_map_dir);
};
